export interface ProfessionState {
  currentProfession?: {
    sysDeptId: number;
    sysSpecialityDeptId: number;
  } | null;
}

export const initialProfessionState: ProfessionState = {
  currentProfession: null,
};

export default function profession(state = initialProfessionState, action) {
  switch (action.type) {
    case 'update-profession':
      return {
        ...state,
        currentProfession: action.payload,
      };
    default:
      return state;
  }
}
